










































import { Component } from 'vue-property-decorator';
import PageNames from '@/router/PageNames';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProfileSettings from '@/components/Dashboard/Profile/ProfileSettings.vue';
import ChangePassword from '@/components/Dashboard/Profile/ChangePassword.vue';
import UserPermissions from '@/components/Dashboard/Profile/UserPermissions.vue';
import PortalSettings from '@/components/Dashboard/Profile/PortalSettings.vue';

@Component({ name: 'UserProfileMenu', components: { ProfileSettings, ChangePassword, UserPermissions, PortalSettings } })
export default class extends SaascadaVue {

    logOut() {
        // Go back to the login page, note that data will be cleared as part
        // of the router logic in index.ts
        this.$router.push({ name: PageNames.Login });
    }

};
